import { formatAssetAmount, formatPrice } from '@exodus/formatting';
import { useAtom, useAtomValue, useSelectors } from '@exodus/headless-ui';
import { useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { fiatModeAtom, toAmountAtom, toAssetAtom, toFiatAmountAtom, isToLoadingAtom, } from '../../../atoms/index.js';
const ToAssetValue = ({ Component, className, style, onPress }) => {
    const selectors = useSelectors();
    const toAsset = useAtomValue(toAssetAtom);
    const toAmount = useAtomValue(toAmountAtom);
    const isLoading = useAtomValue(isToLoadingAtom);
    const toFiatAmount = useAtomValue(toFiatAmountAtom);
    const [fiatMode, setFiatMode] = useAtom(fiatModeAtom);
    const currency = useSelector(selectors.locale.currency);
    const handleToggle = useCallback(() => {
        setFiatMode((value) => !value);
        onPress?.();
    }, [onPress, setFiatMode]);
    const formattedValue = fiatMode
        ? `${formatAssetAmount(toAmount)} ${toAsset.displayTicker}`
        : formatPrice(toFiatAmount.toDefaultNumber(), { currency });
    const amount = fiatMode ? toAmount : toFiatAmount;
    if (Component) {
        return (React.createElement(Component, { amount: amount, formattedValue: formattedValue, loading: isLoading, className: className, style: style, onPress: handleToggle, fiatMode: fiatMode, asset: toAsset }));
    }
    return null;
};
export default ToAssetValue;
